import { useEffect, useState } from 'react'

const FRAMES = ['⣾', '⣽', '⣻', '⢿', '⡿', '⣟', '⣯', '⣷']
const INTERVAL_MS = 80

interface SpinnerProps {
  className?: string
}

export default function Spinner({ className }: SpinnerProps) {
  const [frame, setFrame] = useState(0)

  useEffect(() => {
    const timer = window.setInterval(() => {
      setFrame((current) => (current + 1) % FRAMES.length)
    }, INTERVAL_MS)
    return () => window.clearInterval(timer)
  }, [])

  return <span className={className}>{FRAMES[frame]}</span>
}
